import { type ModalConfigName } from './modalConfigs';
import { Feature, isAvailable, hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';

const hasActiveScripts = (types: string[]) => {
	return (
		isAvailable(Feature.UI_SCRIPTS) &&
		AppService.getScripts().some(script => script.active && types.includes(script.type))
	);
};

const shouldOpenModal = (name: ModalConfigName) => {
	const hasReactEditContactModal = hasSoftDeployAccess('REACT_EDIT_CONTACT_MODAL');
	const hasReactEditActivity = hasSoftDeployAccess('REACT_EDIT_ACTIVITY');
	switch (name) {
		case 'CreateAccount':
			return !hasActiveScripts(['client_edit']);
		case 'EditContact':
			return hasReactEditContactModal && !hasActiveScripts(['contact_edit']);
		// The script clause is load-bearing, not symmetry: Angular runs
		// `ScriptService.activity.init` on open (`editActivity.js:1622`) and the React
		// shell does not yet, so an org with an `activity_edit` script would silently
		// lose it. Lifted once WEB-10154 ports that call.
		case 'EditActivity':
			return hasReactEditActivity && !hasActiveScripts(['activity_edit']);
		default:
			return true;
	}
};

export default shouldOpenModal;
